"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formValidations = require("../../../../helpers/formValidations");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _APInput = _interopRequireDefault(require("../../../common/APInput"));
var _APNumberInput = _interopRequireDefault(require("../../../common/APNumberInput"));
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _config = _interopRequireDefault(require("../../../../config"));
require("./ManualDepositWorkflowComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('manual-deposit');
var ManualDepositWorkflowComponent = function ManualDepositWorkflowComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var _props$product = props.product,
    DecimalPlaces = _props$product.DecimalPlaces,
    Product = _props$product.Product;
  var Deposit = _config["default"].Deposit,
    hideDepositBankInfo = _config["default"].Deposit.hideDepositBankInfo;
  var bankInfo = Deposit[Product] || {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('container-with-footer')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('title')
  }, t('Deposit Money')), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('step-item')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('step')
  }, t('Step 1:')), t('Create the deposit ticket.')), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('step-item')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('step')
  }, t('Step 2:')), t('Process deposit instructions on the deposit receipt.')), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('frame')
  }, /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    type: "text",
    name: "fullname",
    label: t('Full Name:'),
    customClass: baseClasses(),
    validate: [_formValidations.required]
  }), /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
    type: "text",
    name: "amount",
    label: "".concat(t('Amount'), ":"),
    decimalPlaces: DecimalPlaces,
    customClass: baseClasses(),
    validate: [_formValidations.required, _formValidations.greaterThanZero]
  }), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    name: "comments",
    label: "".concat(t('Comments'), ":"),
    customClass: baseClasses(),
    info: t('The comment field is optional. Please use it for special instructions.')
  })), !hideDepositBankInfo && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('bank-info-label')
  }, t('Bank Account to Wire the Funds')), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('bank-info')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Bank Name:'),
    text: bankInfo.bankName,
    customClass: baseClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Wire Number:'),
    text: bankInfo.bankWireNumber,
    customClass: baseClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Account Number:'),
    text: bankInfo.bankAccountNumber,
    customClass: baseClasses()
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('footer')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: baseClasses(),
    type: "submit",
    "data-test": "Place Deposit Ticket",
    disabled: props.submitting,
    styleName: "additive",
    onClick: props.onSubmit
  }, props.submitting ? t('Submitting...') : t('Place Deposit Ticket'))));
};
ManualDepositWorkflowComponent.defaultProps = {
  onSubmit: function onSubmit() {},
  submitting: false
};
ManualDepositWorkflowComponent.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = ManualDepositWorkflowComponent;